import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'itemsSort',
    standalone: false
})
export class ItemsSortPipe implements PipeTransform {

  transform(items: any): any {
    return items.sort((a: any, b: any) => (a.value.name > b.value.name) ? 1 : ((b.value.name > a.value.name) ? -1 : 0) );
  }
}
